import { cx } from '@linaria/core';
import { SecureStateType } from '../../../../constants/enums';
import { UserAccess } from '../../../../mfcLogic/userProperties/level';
import Alert from '../../../common/Alert';
import { useScreenStateSelector } from '../../../Hooks/useScreenState';
import { useSecureState } from '../../../Hooks/useSecureState';
import { useUserSelector } from '../../../Hooks/useUser';
import IdCard from '../../../Icons/IdCard';
import Lock from '../../../Icons/Lock';
import APP_BREAKPOINTS from '../../../styles/breakpoints';
import "./AgeGateHeader.linaria.module.css!=!./AgeGateHeader?./AgeGateHeader.linaria.module.css?css=H4sIAAAAAAAAA41Sy3aCMBTc9ytctgs8RBEpbvonOSEPuHKTUIgCcvz3HmlFgl24nORO7mRm1sxpipIS1XbmLNc+HComBJg8yKxzVqdkU3WH69s49dlQ4roWzjgIaCpkfapQTtespiSrIlvyBRxuU4GAWnIH1qTc4kmbO62gpIjt8XTx0cAQchOAk7pJuTRO1ncGSgqiUnnko6X08D7PE0q6/cn2zQIOyhoXNHCRabhO9rta6tkO5XLAjY+WO5LRnS8tBbDVu2Zd0IJwRbqK9mHVfQwj2+RRto2pZueCxK+c+LpGVY+vzEgT+ofwoihyZCpS8rUjb82fXbNukLgPWTl1AwyCkcG8Iry59SzcXvIF/H25lZAXLt2HU3RovajtMmpnq0fOWPqlLp9KjVI5r9KIPgWfKPUoac7hCRWZaDvmIz+D3aNKN2tsgtB/L63J0PLycH37AR0vPseTAwAA"
const rootStyles = "atm_le_1fwxnve atm_9s_1txwivl atm_ar_1bp4okc atm_h_1h6ojuz";
const stylesNoPadding = "atm_le_idpfg4";
const textStyles = "atm_c8_1x7uoys atm_le_ftgil2 atm_ng4b36_mavh16";
const embeddedTextStyles = "atm_c8_mavh16 atm_le_ftgil2 atm_ng4b36_1jaf4fe";
const headerStyles = "atm_9s_116y0ak atm_cs_1fw03zg atm_h_1h6ojuz";
const alertStyles = "atm_lo_idpfg4 atm_le_idpfg4 atm_lk_1fwxnve atm_ll_1fwxnve atm_c8_dbdwxa atm_9s_1o8liyq";
interface AgeGateHeaderProps {
  noPadding?: boolean;
}
const AgeGateHeader = (props: AgeGateHeaderProps) => {
  const {
    noPadding
  } = props;
  const {
    ageGateActive,
    ageVerificationProviders,
    legalRegion
  } = useSecureState(SecureStateType.AGE_VERIFICATION);
  const level = useUserSelector('me', 'level');
  const shouldRedirectToBouncer = ageGateActive && level > UserAccess.GUEST;
  if (shouldRedirectToBouncer) {
    console.log('Age Gate Detected');
  }
  const windowWidth = useScreenStateSelector('windowWidth');
  const iconSize = windowWidth <= APP_BREAKPOINTS.s ? 0.85 : 1.5;
  const courtesyMessage = ageVerificationProviders['ondato'] ? `Verify your age and receive courtesy credit ✨` : ``;
  const styles = noPadding ? textStyles : embeddedTextStyles;
  return <div className={cx(rootStyles, noPadding && stylesNoPadding)}>
            <div className={cx(styles, headerStyles)}>
                <IdCard size={iconSize + 0.25} /> <Lock size={iconSize} />
                &nbsp;Age Verification required by law {legalRegion && 'in'}{' '}
                {legalRegion}
            </div>
            {courtesyMessage && level === UserAccess.GUEST && <div className={styles}>
                    <Alert severity={'info'} icon={false} className={alertStyles}>
                        {courtesyMessage}
                    </Alert>
                </div>}
        </div>;
};
export default AgeGateHeader;